import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/home.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/scoreboard",
    name: "scoreboard",
    component: () => import(/* webpackChunkName: "scoreboard" */ "../views/scoreboard.vue"),
  },
  {
    path: "/i-need-to-change-things",
    name: "admin",
    props: true,
    component: () => import(/* webpackChunkName: "admin" */ "../views/admin/admin.vue"),
    children: [
      {
        path: "",
        name: "admin-home",
        props: true,
        component: () => import(/* webpackChunkName: "admin-home" */ "../views/admin/home.vue")
      }
    ]
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
